export const BalanceFlowTransactionApprovalDisclaimerDiv = () => {
  return (
    <div className="flex border-1 border-red p-[0.5rem]  space-x-4  rounded ">
      <p className="text-red text-base ">DISCLAIMER</p>
      <p className="text-sm  ">
        Prices are indicative and reflect current market rates. Prices may fluctuate and are not guaranteed until an
        execution confirmation certificate signed by spotlock has been received
      </p>
    </div>
  );
};
